import { useRecordContext } from 'ra-core';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

export const RevisedReferenceWatcher = () => {
    const { watch, setValue } = useFormContext();
    const record = useRecordContext();
    
    // Watch all fields to detect changes in items, totals, etc.
    const formValues = watch();

    useEffect(() => {
        // Trigger revision if status is 'sent' or 'approved'
        if (record && (record.status === 'sent' || record.status === 'approved')) {
            // Only check content fields that should trigger revision
            // Ignore metadata/system fields
            const contentFields = ['customer_name', 'customer_id', 'project_id', 'date', 
                'valid_until', 'terms_conditions', 'notes', 'subtotal', 'tax_amount', 
                'total_amount', 'currency', 'items', 'company_id'];
            
            const hasChanged = contentFields.some(key => {
                // Deep comparison for objects (like items)
                return JSON.stringify(formValues[key]) !== JSON.stringify(record[key]);
            });
            
            if (formValues._isRevisionNeeded !== hasChanged) {
                setValue('_isRevisionNeeded', hasChanged, { shouldDirty: true });
            }
        }
    }, [formValues, record, setValue]);

    return null;
};
